export default "__VITE_ASSET__CtBh5ni2__"